
import '@babel/polyfill';

const BREAK_POINT = 960
const TRANSITION_END = 'webkitTransitionEnd transitionend';
const ANIMATION_END = 'webkitAnimationEnd Animationend';

import 'url-polyfill'
import 'nodelist-foreach-polyfill'
import 'custom-event-polyfill'
import 'objectFitPolyfill'

import createjs from 'preload-js'
import inView from 'in-view'
import SmoothScroll from './SmoothScroll.js'
import ScrollHelper from './_ScrollHelper.js'
import ScrollTrigger from '@terwanerik/scrolltrigger'

const findProperty = obj => {
  const el = document.createElement('div')
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && el.style[key] !== undefined) {
      return obj[key]
    }
  }
}
window.transitionEnd = findProperty({
  transition: 'transitionend',
  MozTransition: 'transitionend',
  WebkitTransition: 'webkitTransitionEnd'
})
window.animationEnd = findProperty({
  animation: 'animationend',
  MozAnimation: 'animationend',
  WebkitAnimation: 'webkitAnimationEnd'
})


class Loading {
  constructor() {
    this.el = document.getElementById('loading')
  }
  onload() {
    document.body.classList.add('loaded')
    if(!this.el) return
    
    this.el.addEventListener(animationEnd, () => {
      if (this.el.parentNode ) {
        this.el.parentNode.removeChild(this.el)
      }
    })
  }
}


const $body = $('body');
const $window = $(window);

class Preloader{
  constructor(){
    this.preload = new createjs.LoadQueue();
    this.checkCodecs();
    this.listen();
    this.parse();
  }
  checkCodecs(){

    var media = document.createElement("video");
    this.canplaywebm = media.canPlayType(`video/webm; codecs="vp9"`)

  }
  parse(){
    const preloadItemList = []

    // img
    const preloadImages = document.querySelectorAll('.preload-image');
    for(const image of preloadImages){
      preloadItemList.push(this.getImageSrc(image));
    }

    // video
    const preloadVideos = document.querySelectorAll('.preload-video');
    for(const video of preloadVideos){
      console.log(video)
      preloadItemList.push(this.getVideoSrc(video));
      video.addEventListener('canplaythrough', e => {
        console.log('canplay')
        this.onload()
      })
    }

    this.fetch(preloadItemList);
  }
  fetch(preloadSrcList){
    window.addEventListener('mousewheel', this.scrollCancell, {passive: false})
    this.preload.loadManifest(preloadSrcList);
  }
  scrollCancell(e){
    return false;
  }
  listen(){
    const $progressbar = $('#progress-bar');
    this.preload.addEventListener('progress', progress => {
      $progressbar.width((progress.loaded * 100) + '%');
    });
    this.preload.addEventListener('error', () => {
      window.removeEventListener('mousewheel', this.scrollCancell);
    });
    this.preload.addEventListener('complete', items => {
      setTimeout(() => {
        $body.addClass('loaded');
        window.removeEventListener('mousewheel', this.scrollCancell);
        this.onload()
        
      }, 500)

      $('.video-inview').each((index, el) => {
        try{
          el.load();
        }catch(e){

        }
      })
    });
  }
  getURLOrigin(path){
    const origin = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");
    return origin + path;
  }
  getImageSrc(image){
    let imageSrc = '';
    if(window.devicePixelRatio >= 2 && image.srcset){
      // image.srcset.split(',').forEach(singleSrc => {
      // });

      for(const singleSrc of image.srcset.split(',')){
        if(singleSrc.lastIndexOf('2x') != -1){
          imageSrc = this.getURLOrigin(singleSrc.split(' ')[0]);
        }
      }
    }else{
      imageSrc = image.src;
    }
    return imageSrc;
  }
  getVideoSrc(video){
    const sources = video.querySelectorAll('source');
    if( sources.length ) {
      let videoSrc = '';
      for(let i = 0; i < sources.length; i+= 1){
        const source = sources[i];
        if(this.canplaywebm && source.getAttribute('type') === `video/webm; codecs="vp9"`){
          videoSrc = source.src;
          break;
        }
        else{
          videoSrc = source.src;
        }
      }
      return videoSrc;
    } else {
      return video.getAttribute('src')
    }
  }
  onload(fn) {
  }
}



const loading = new Loading()

window.onload = () => {
  loading.onload()
}

const loadEvent = window.onpageshow !== undefined ? 'pageshow' : 'DOMContentLoaded'
window.addEventListener('DOMContentLoaded', e => {


  let windowHeight = window.innerHeight;
  const scrolled = new ScrollHelper(function(){
    $body.toggleClass('scrolled', $(window).scrollTop() >= 1);
  });
  const is_nofv = new ScrollHelper(() => {
    $body.toggleClass('no_fv', $(window).scrollTop() > $(window).height() );
  });

  const $window = $(window)

  $window.on('scroll', () => {
    inView('.inview')
      .on('enter', (el) => {
        $(el).addClass('is-inview');
      })
  })
  

  // const smoothScroll = new SmoothScroll({
  //   breakpoint: BREAK_POINT,
  //   offset: {
  //     pc: 0,
  //     sp: 0
  //   }
  // });
  // smoothScroll.begin = () => {
  //   if ($window.width() < BREAK_POINT) {
  //     $('body').removeClass('menu-active');
  //   }
  // }
  document.querySelectorAll('.js-detect-current').forEach(el => {
    let attr = el.getAttribute('href')
    if( attr.indexOf('//') === 0 ) {
      attr = location.protocol + attr
    }
    const url = attr.indexOf('http') === 0 ? attr : location.origin + attr
    const to = new URL(url)
    if (to.pathname === location.pathname) {
      el.classList.add('current')
    }
  })

  // accordion
  $('.js-slide-toggle').on('click', e => {
    console.log(e.currentTarget)
    const targetID = e.currentTarget.getAttribute('data-target')
    console.log(targetID)
    // const target = document.getElementById(targetID)
    $(e.currentTarget).toggleClass('active')
    $('#'+targetID).slideToggle()
  })


  // modal
  $('.js-toggle-modal').on('click', e => {
    const targetID = e.currentTarget.getAttribute('data-modal-target')
    const target = document.getElementById(targetID)
    target.classList.toggle('open')
    e.preventDefault()
    e.stopPropagation()
    return false
  })

  // dropdown link
  $('.js-dropdown-link').on('change', function () {
    window.scrollTo({
      top: $($(this).val()).offset().top,
    })
  })

  if ( $('#video_mind').length ) {
    // youtube
    // modal
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    var player;
    window.onYouTubeIframeAPIReady = () => {
      player = new YT.Player("video_mind", {})
    }
    $('.js-toggle-modal').on('click', e => {
      if(player){
        player.stopVideo()
      }
    })
  } else {
    $('.js-toggle-modal').on('click', e => {
      $('video').each((index, el) => {
        el.pause()
        el.currentTime = 0
      })
    })
  }


  // menu
  document.getElementById('js__menu-button').addEventListener('click', e => {
    document.body.classList.toggle('menu-active')
  })


  // infographic

  const $infographics = $('#infographics')

  $('body').find('.js-open-infowindow').on('click', e => {
    const targetId = $(e.currentTarget).attr('data-infographic_modal')
    const currentTarget = $infographics.attr('data-active')
    if(currentTarget !== targetId) {
      $infographics.attr('data-active', targetId)
    } else {
      $infographics.attr('data-active', '')
    }
  })

  $infographics.find('.js-open-infowindow').hover(e => {
    const targetId = $(e.currentTarget).attr('data-infographic_modal')
    const currentTarget = $infographics.attr('data-active')
    
    $infographics.attr('data-hover', targetId)
  }, e => {
    $infographics.attr('data-hover', '')
  })

  $infographics.find('.infographic-modal__close').on('click', e => {
    console.log('close')
    $infographics.attr('data-active', '')
  })


  const trigger = new ScrollTrigger({
    trigger: {
      once: true,
      offset: {
        element: {
          x: 0,
          y: (trigger, rect, direction) => {
            return 0
          }
        },
        viewport: {
          x: 0,
          y: (trigger, frame, direction) => {
            return 0.3
          }
        }
      },
    },
  })
  trigger.add('[data-trigger]')


  objectFitPolyfill();
})